import { DispatchGroupService } from "./service.js";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * Dispatch Group Management Service
 *
 * @generated from protobuf service dispatch_group.v1.DispatchGroupService
 */
export class DispatchGroupServiceClient {
    _transport;
    typeName = DispatchGroupService.typeName;
    methods = DispatchGroupService.methods;
    options = DispatchGroupService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * Dispatch Group CRUD operations
     *
     * @generated from protobuf rpc: CreateDispatchGroup
     */
    createDispatchGroup(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single dispatch group by its unique identifier
     *
     * @generated from protobuf rpc: GetDispatchGroup
     */
    getDispatchGroup(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists dispatch groups with optional filtering, pagination, and sorting
     *
     * @generated from protobuf rpc: ListDispatchGroups
     */
    listDispatchGroups(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing dispatch group with partial or full field updates
     *
     * @generated from protobuf rpc: UpdateDispatchGroup
     */
    updateDispatchGroup(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a dispatch group either permanently or with soft delete
     *
     * @generated from protobuf rpc: DeleteDispatchGroup
     */
    deleteDispatchGroup(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Restores a previously soft-deleted dispatch group
     *
     * @generated from protobuf rpc: RestoreDispatchGroup
     */
    restoreDispatchGroup(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Grid Service Association operations
     *
     * @generated from protobuf rpc: AddGridServiceToDispatchGroup
     */
    addGridServiceToDispatchGroup(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Removes a grid service from a dispatch group
     *
     * @generated from protobuf rpc: RemoveGridServiceFromDispatchGroup
     */
    removeGridServiceFromDispatchGroup(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing grid service association with a dispatch group
     *
     * @generated from protobuf rpc: UpdateDispatchGroupGridService
     */
    updateDispatchGroupGridService(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists grid services associated with dispatch groups with optional filtering
     *
     * @generated from protobuf rpc: ListDispatchGroupGridServices
     */
    listDispatchGroupGridServices(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Dispatch Indicator operations
     *
     * @generated from protobuf rpc: CreateDispatchIndicator
     */
    createDispatchIndicator(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves dispatch indicators for a grid service
     *
     * @generated from protobuf rpc: GetDispatchIndicator
     */
    getDispatchIndicator(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists dispatch indicators with optional filtering
     *
     * @generated from protobuf rpc: ListDispatchIndicators
     */
    listDispatchIndicators(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing dispatch indicator
     *
     * @generated from protobuf rpc: UpdateDispatchIndicator
     */
    updateDispatchIndicator(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a dispatch indicator
     *
     * @generated from protobuf rpc: DeleteDispatchIndicator
     */
    deleteDispatchIndicator(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Dispatch Group Delivery Point operations (temporal)
     *
     * @generated from protobuf rpc: AddDispatchGroupDeliveryPoint
     */
    addDispatchGroupDeliveryPoint(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Removes a dispatch group delivery point
     *
     * @generated from protobuf rpc: RemoveDispatchGroupDeliveryPoint
     */
    removeDispatchGroupDeliveryPoint(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists dispatch group delivery points with temporal validity
     *
     * @generated from protobuf rpc: ListDispatchGroupDeliveryPoints
     */
    listDispatchGroupDeliveryPoints(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Dispatcher CRUD operations
     *
     * @generated from protobuf rpc: CreateDispatcher
     */
    createDispatcher(input, options) {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Returns a single dispatcher by id.
     *
     * @generated from protobuf rpc: GetDispatcher
     */
    getDispatcher(input, options) {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists dispatchers with optional filtering.
     *
     * @generated from protobuf rpc: ListDispatchers
     */
    listDispatchers(input, options) {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing dispatcher by id.
     *
     * @generated from protobuf rpc: UpdateDispatcher
     */
    updateDispatcher(input, options) {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a dispatcher by id.
     *
     * @generated from protobuf rpc: DeleteDispatcher
     */
    deleteDispatcher(input, options) {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
//# sourceMappingURL=service.client.js.map